import { jwtDecode } from "jwt-decode";

export const formatDate = (date) => {
  const tehranDate = new Date(
    date.toLocaleString("en-US", { timeZone: "Asia/Tehran" })
  );

  // Manually format the date to avoid resetting it to UTC
  const formattedDate =
    tehranDate.getFullYear() +
    "-" +
    String(tehranDate.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(tehranDate.getDate()).padStart(2, "0") +
    "T" +
    String(tehranDate.getHours()).padStart(2, "0") +
    ":" +
    String(tehranDate.getMinutes()).padStart(2, "0") +
    ":" +
    String(tehranDate.getSeconds()).padStart(2, "0");

  return formattedDate;
};

export const getDecodedUserId = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    const decodedToken = jwtDecode(token);
    return +decodedToken.nameid;
  } catch (e) {
    return null;
  }
};
